import React, { useEffect, useState } from "react";
import Faq from "react-faq-component";
import { Container } from "react-bootstrap";
import "./styles/App.css";
import TopTitle from "./Pc_TopTitle";
import { instance } from "./common";

function FaqList() {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            instance.post("/faq/all/list").then(function (res) {
                // console.log('res.data.rows : ', res.data.rows);
                setData(res.data.rows);
                // setTotal(res.data.totalCount);
            });
        };

        fetchData();
    }, []);

    const faqData = {
        rows: data,
    };

    return (
        <Container className="position-relactive" style={{ marginTop: "50px" }}>
            <div className="c_pad">
                <TopTitle title="고객센터 · FAQ" />
                <div className="mb-5">
                    <div className="faq__desc">
                        <div className="mb-3 text-center">
                            <span className="font-weight-bold">
                                ABYS에 궁금한점이 있을 경우 언제든지 문의주세요
                            </span>
                        </div>
                        <div className="text-center mb-2">
                            <span className="font-weight-bold">고객센터</span>
                            <span> | 1544-2160</span>
                        </div>
                        <div className="text-center mb-2">
                            <span>Email</span>
                            <span> | 1xymam@scglobal.kr</span>
                        </div>
                    </div>
                </div>
                <Faq data={faqData} />
            </div>
        </Container>
    );
}

export default FaqList;
